<mat-dialog-content style="font-size: 1rem;">
  <div class="row p-0">
    <div class="col-12 col-sm-6 d-flex align-items-center justify-content-center">
      <img class="img-fluid w-100"
        [src]="'https://stars.facilities.ufl.edu/public/api/photos/photo?bldg='+this.bldgNumber" width="100%"
        [alt]="'Photo of Building ' + this.bldgName" />
    </div>
    <div class="col d-flex flex-column justify-content-between pt-3 pt-sm-0">
      <div>
        <h2 mat-dialog-title style="font-weight: bold; color: #00285e; font-size: 1.5rem">{{this.bldgName}} {{this.bldgABBREV ? '('+this.bldgABBREV+')' : ''}}</h2>
        <div style="font-weight: bold;">Address: </div>
        <address>
          <div>{{this.bldgADDRESS1}}</div>
          <div *ngIf="bldgADDRESS2">{{ bldgADDRESS2 }}</div>
          <div>{{ bldgCITY }}, {{ bldgSTATE }} {{ bldgZIP }}</div>
        </address>
        <div class="mt-2" style="font-weight: bold">
          Building Number: 
        </div>
        <p>{{this.bldgNumber}}</p>
        <div class="mt-2" style="font-weight: bold">
          Gross Square Footage: 
        </div>
        <p>{{this.bldgGSF}}</p>
        <div class="mt-5">
          Link to this location: <a
            [href]="'https://campusmap.ufl.edu/#/index/' + this.bldgNumber">https://campusmap.ufl.edu/#/index/{{this.bldgNumber}}</a>
        </div>
      </div>

      <mat-dialog-actions class="m-0 p-0 d-flex align-items-end justify-content-end">
        <button mat-button mat-dialog-close type="button" class="btn btn-danger mb-1">Close</button>
      </mat-dialog-actions>
    </div>
  </div>
</mat-dialog-content>